var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleChatPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 10.4316H9.15625",
    stroke: "#42296E",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 13.1816H9.15625",
    stroke: "#42296E",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.038 18.949C14.3051 19.9519 12.2665 20.2904 10.3024 19.9014C8.33832 19.5123 6.58274 18.4222 5.363 16.8343C4.14325 15.2465 3.5426 13.2692 3.67303 11.2712C3.80346 9.27319 4.65606 7.39079 6.07188 5.97497C7.4877 4.55916 9.37009 3.70655 11.3681 3.57613C13.3661 3.4457 15.3434 4.04635 16.9312 5.26609C18.5191 6.48583 19.6092 8.24141 19.9983 10.2055C20.3873 12.1696 20.0488 14.2082 19.0459 15.9411L20.1209 19.1509C20.1613 19.272 20.1672 19.402 20.1379 19.5263C20.1085 19.6506 20.0452 19.7643 19.9549 19.8545C19.8646 19.9448 19.7509 20.0082 19.6267 20.0375C19.5024 20.0669 19.3724 20.061 19.2513 20.0206L16.038 18.949Z",
    stroke: "#42296E",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleChatPurple);
export default __webpack_public_path__ + "static/media/bubble_chat_purple.c974bdd516e5d2a80e83efa8a70abcb5.svg";
export { ForwardRef as ReactComponent };